import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedAddresses: [],
};

const allAddressesSlice = createSlice({
	name: 'addresses',
	initialState: initialState,
	reducers: {
		setAddresses: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setAddresses, reset } = allAddressesSlice.actions;

export default allAddressesSlice.reducer;